import axios, {parseResponseData} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {PaginationParams, PaginationResponse} from '@/types'
import {z} from 'zod'
import {ReferringSpecialist} from '../types'

/*Get referring specialists*/
export interface HttpGetReferringSpecialistsOptions {
    params: PaginationParams & {
        search?: string
    }
}

export const HttpGetReferringSpecialistsResponse = z.object({
    data: ReferringSpecialist.array(),
    meta: PaginationResponse
})
export type HttpGetReferringSpecialistsResponse = z.infer<typeof HttpGetReferringSpecialistsResponse>

export const httpGetReferringSpecialists = async ({params}: HttpGetReferringSpecialistsOptions) => {
    const response = await axios.get('specialists', {params})
    return parseResponseData({
        responseData: response.data,
        responseShape: HttpGetReferringSpecialistsResponse,
        onZodError: captureException
    })
}

/*Store referring specialist*/
export interface HttpStoreReferringSpecialistOptions {
    payload: {
        title: string
        firstName: string
        lastName: string
        serviceUoc: string
        email: string
    }
}
export const httpStoreReferringSpecialist = async ({payload}: HttpStoreReferringSpecialistOptions) => {
    const response = await axios.post(`specialists`, payload)
    return parseResponseData({
        responseData: response.data,
        responseShape: ReferringSpecialist,
        onZodError: captureException
    })
}

/*Update referring specialist*/
export interface HttpUpdateReferringSpecialistPayload {
    title: string
    firstName: string
    lastName: string
    serviceUoc: string
    email: string
}

export interface HttpUpdateReferringSpecialistOptions {
    urlParams: {referringSpecialistId: string}
    payload: HttpUpdateReferringSpecialistPayload
}

export const httpUpdateReferringSpecialist = async ({urlParams, payload}: HttpUpdateReferringSpecialistOptions) => {
    const response = await axios.patch(`specialists/${urlParams.referringSpecialistId}`, payload)
    return parseResponseData({
        responseData: response.data,
        responseShape: ReferringSpecialist,
        onZodError: captureException
    })
}

/*Delete referring specialist*/
export const httpDeleteReferringSpecialist = async ({urlParams}: {urlParams: {referringSpecialistId: string}}) => {
    await axios.delete(`specialists/${urlParams.referringSpecialistId}`)
}
